import * as React from 'react';
import { Page } from '~/components/about-faq-page/about-faq-page';

const AboutFAQPage: React.FC = () => <Page />;

export default AboutFAQPage;
